module.exports = __webpack_public_path__ + "static/media/heliLoading.558b20a9.gif";